
import { defineComponent, PropType, computed, ref } from 'vue';
import { ITimelineEntry } from '@/models/timeline.model';
export default defineComponent({
  name: 'TimelineEntryContent',
  components: {},
  props: {
    entry: {
      type: Object as PropType<ITimelineEntry>,
      required: true,
    },
    fullScreenImage: {
      type: Boolean,
      required: true,
    },
  },
  setup(props) {
    const uriDisplay = computed(() => {
      if (props.entry.uri_title) {
        return props.entry.uri_title;
      } else if (props.entry.uri) {
        return props.entry.uri;
      } else {
        return false;
      }
    });
    const descriptionDisplay = computed(() => {
      return props.entry.description ? true : false;
    });
    const linkedPageDisplay = computed(() => {
      return props.entry.linked_page?.links.external_show_uri ? true : false;
    });
    const linkedProjectDisplay = computed(() => {
      return props.entry.linked_project ? true : false;
    });
    return {
      uriDisplay,
      descriptionDisplay,
      linkedProjectDisplay,
      linkedPageDisplay,
    };
  },
});
